import { format } from "date-fns";
import { enUS, ko } from "date-fns/locale";
import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";
import {
  newOrderStatusMap,
  oldOrderStatusMap,
  orderStatusOptionList,
} from "@/shared/constants/status";

export function formatDateToKorean(date?: Date): string {
  if (!date) return "";
  // 'yyyy/MM/dd(E)' 에서 E는 축약된 요일(월,화,수…)을 의미합니다.
  return format(date, "yyyy/MM/dd(E)", { locale: ko });
}

export const convertOrderStatusToNew = (status: OrderSheetStatus) => {
  return newOrderStatusMap[status] ?? status;
};

export const convertOrderStatusToOld = (status: string): OrderSheetStatus => {
  return oldOrderStatusMap[status] ?? "WORKING_DRAFT";
};

export const orderStatusOptionListFilter = (query: OrderSheetStatus) => {
  if (convertOrderStatusToNew(query) === "ORDER_SUBMITTED") {
    return orderStatusOptionList.filter(
      (option) =>
        option.value === "ORDER_SUBMITTED" ||
        option.value === "RESUBMIT_COMPLETED"
    );
  } else if (convertOrderStatusToNew(query) === "ORDER_CONSULTING") {
    return orderStatusOptionList.filter(
      (option) =>
        option.value === "ORDER_CONSULTING" ||
        option.value === "BUYER_MODIFICATION_REQUIRED" ||
        option.value === "BUYER_CONFIRM_REQUIRED"
    );
  } else if (convertOrderStatusToNew(query) === "ORDER_CONFIRMED") {
    return orderStatusOptionList.filter(
      (option) => option.value === "ORDER_CONFIRMED"
    );
  }
};

export const formatDateToYMDEGeneral = (
  iso?: string,
  isKor?: boolean,
  joinTxt: string = ".",
  showTime?: boolean,
  showDayOfWeek: boolean = true
) => {
  if (!iso) return "";
  const date = new Date(iso);

  return format(
    date,
    `yyyy${joinTxt}MM${joinTxt}dd${showDayOfWeek ? "(EEE)" : ""}${
      showTime ? " HH:mm" : ""
    }`,
    {
      locale: isKor ? ko : enUS,
    }
  );
};

interface formatDateToYMDGeneralParams {
  date?: string | Date;
  isKor?: boolean;
  joinTxt: string;
  showTime?: boolean;
}

export const formatDateToYMDGeneral = ({
  date,
  showTime,
  joinTxt,
  isKor,
}: formatDateToYMDGeneralParams) => {
  if (!date) return "";
  const dateObj = typeof date === "string" ? new Date(date) : date;

  return format(
    dateObj,
    `yyyy${joinTxt}MM${joinTxt}dd${showTime ? " HH:mm" : ""}`,
    {
      locale: isKor ? ko : enUS,
    }
  );
};

export const formatDateToYMGeneral = (
  date: string | Date,
  joinTxt: string = "-"
) => {
  if (!date) return "";
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return format(dateObj, `yyyy${joinTxt}MM`, { locale: ko });
};

export const toLocaleKrw = (
  amount: number,
  minFraction?: number,
  maxFraction?: number
) => {
  return amount.toLocaleString("ko-KR", {
    style: "currency",
    currency: "KRW",
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction,
  });
};
